import * as React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Header } from "../components/header";
// import { login } from "../api/api-account";
// import { TestWithErrorResult, TestWithAlert } from "../api/api-tester";
// import {TestResponse} from "../api/dataTypes";
import "../styles/Headers.css";
import "../styles/Tables.css";
import * as TableStyles from "../styles/TableFormats";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt, faCog } from "@fortawesome/free-solid-svg-icons";
import matchSorter from 'match-sorter';
import { Winder, GetDefaultWinder, createWinder, orgInfo, DropdownList, orgTypes, presetInfo, editWinder } from "../api/dataTypes";
import { PromiseHelper } from "../classes/promiseHelper";
import { EditWinderModal } from "../modals/modal-EditWinder";
import { AddWinderModal } from "../modals/modal-AddWinder";
import { getAllWindersApi, addWinderApi, getAllPresetsApi, editWinderApi, editPresetApi } from "../api/api-winder";
import { getAllOrgsApi } from "../api/api-organizations";
import { EditPresetsModal } from "../modals/modal-EditPresets";
import { hasAdminRole, hasDistributorRole, getCurrentUser } from "../api/api-account";
import moment from 'moment';
import { isNull, isUndefined } from "util";


interface State {
  example: string
  winders:Winder[];
  presets: presetInfo[];
  orgOptions:DropdownList[]
  addModalOpen: boolean;
  editModalOpen: boolean;
  editPresetModalOpen:boolean;
  // deleteModalOpen: boolean;
}

export interface Props {}

export class SpoolWindersPage extends React.Component<Props, State> {
  private editData: Winder;
  private editPreset: presetInfo;
  private editName:string = "";
  private orgList: orgInfo[] = [];
  private adminIndex:number = -2;
  private offset = moment().utcOffset();
  getPromise: PromiseHelper<Winder[]> = new PromiseHelper();
  addPromise: PromiseHelper<Winder> = new PromiseHelper();
  editPromise: PromiseHelper<Winder> = new PromiseHelper();
  getPresetsPromise: PromiseHelper<presetInfo[]> = new PromiseHelper();
  editPresetsPromise:PromiseHelper<presetInfo> = new PromiseHelper();

  constructor(props: Props) {
    super(props);
    this.editData = GetDefaultWinder();
    this.editPreset = {
      id:0,
      winderId:0,
      preset1:0,
      preset2:0,
      preset3:0,
      preset4:0,
      preset5:0,
      preset6:0,
      preset7:0,
      preset8:0,
    }
    this.state = {
      example: '',
      winders:[GetDefaultWinder()],
      presets:[],
      addModalOpen:false,
      editModalOpen:false,
      editPresetModalOpen:false,
      orgOptions: [],
    };
  }

  componentDidMount() {
    this.getWinders();
    if(hasAdminRole()||hasDistributorRole()){
      getAllOrgsApi().then((res) => {
        this.orgList = res;
        this.setDropDownOptions(res);
      });
    }
    else{
      getCurrentUser().then(res=>{
        let customerOrg:orgInfo =new orgInfo();
        customerOrg.Init({name:res!.customerName!, id:res!.customerId, orgType:orgTypes.Customer, distId:res!.distributorId});
        this.orgList=[customerOrg];
        this.setState({orgOptions: [{name:customerOrg.name,value:0}]});
      })
    }
  }

  componentWillUnmount(){
    this.getPromise.clearPromise();
    this.addPromise.clearPromise();
    this.editPromise.clearPromise();
    this.getPresetsPromise.clearPromise();
    this.editPresetsPromise.clearPromise();
  }
  
  // Given an array of arrays, set the values as the drop down options:
  //TODO: limit this list to orgs that the current org should be able to see
  setDropDownOptions = (value: orgInfo[]) => {
    let cOptions = value.map(c => {
      return { name: c.name, value: value.indexOf(c) };
    });
    cOptions.unshift({ name: "Unassigned", value: this.adminIndex }); // TODO: only add if admin is logged in
    cOptions.unshift({ name: "Select...", value: -1 });
    this.setState({
      orgOptions: cOptions,
    });
  };
  // componentWillMount() {
  //   login("admin@dmcinfo.com", "Elston2222!")
  //   .then(() => {
  //     TestWithErrorResult(true)
  //     .then(r => {
  //       if(r.success === true) {
  //         this.setState({ example: r.data!.msg });
  //       } else {
  //         this.setState({ example: `ERROR: ${r.error!.message}` });
  //       }
  //     });
  //     TestWithAlert(true)
  //     .catch(e => alert(`A simulated error occurred.\nERROR:\n${e}`));
  //   })
  // }

  render() {
    //let isCustomer = !(hasDistributorRole()||hasAdminRole())
    return (
      <React.Fragment>
        <Header />

        <div className="d-flex align-items-center d-flex header-page-title nav-divider">
          <div className="m-2 ml-3 mr-auto">
            Spool Winding Trolley Systems
          </div>
           <div className="col-6 d-flex justify-content-end align-items-center">
            {hasAdminRole()&&<div>
              <button
                className="btn btn-outline-secondary m-2 ml-auto button-standard"
                onClick={this.handleAdd}
              >
                + Add Spool Winding Trolley
              </button>
              <AddWinderModal
                isModalOpen={this.state.addModalOpen}
                closeModal={this.closeModal}
                addWinder={this.addWinder}
                orgOptions={this.state.orgOptions}
              />

            </div>}
          </div>
        </div>

        <div className="ReactTable component-standard">
          <ReactTable
            data={this.state.winders}
            filterable={true}
            defaultFilterMethod={(filter, row) => (matchSorter([row[filter.id]], filter.value).length !== 0)}
            minRows = {10}
            showPagination={this.state.winders.length>20}
            // COLUMNS ////////////////////////////////
            columns={[
              {
                Header: "Name",
                headerStyle: TableStyles.columnHeaderStyle,
                accessor: "name",
                style: TableStyles.dataStyle,
                minWidth: 200
              },
              {
                Header: "Location",
                headerStyle: TableStyles.columnHeaderStyle,
                accessor: "location",
                style: TableStyles.dataStyle,
                minWidth: 200
              },
              {
                Header: "Owner",
                headerStyle: TableStyles.columnHeaderStyle,
                accessor: "ownerName",
                style: TableStyles.dataStyle,
                minWidth: 200
              },
              {
                Header: "Mode",
                headerStyle: TableStyles.columnHeaderStyle,
                accessor: "mode",
                style: TableStyles.dataStyle,
                minWidth: 120
              },
              {
                Header: "Current Cut",
                headerStyle: TableStyles.columnHeaderStyle,
                accessor: "currentCutRequest",
                style: TableStyles.dataStyle,
                minWidth: 120
              },
              {
                Header: "Heartbeat",
                headerStyle: TableStyles.columnHeaderStyle,
                id: 'heartBeat',
                accessor: row => moment(row.heartBeat!).format('x'),
                Cell: row =>{
                  if(!isNull(row.original.heartBeat)&& !isUndefined(row.original.heartBeat)){
                    return (moment(row.original.heartBeat).add(this.offset,'m').format(' hh:mm a, MM/DD/YY'))
                  }else{
                    return null;
                  }
                },
                style: TableStyles.dataStyle,
                minWidth: 120
              },
              {
                Header: "PLC Serial",
                headerStyle: TableStyles.columnHeaderStyle,
                accessor: "serialNumber",
                style: TableStyles.dataStyle,
                minWidth: 120
              },
              {
                Header: "Mac Address",
                headerStyle: TableStyles.columnHeaderStyle,
                accessor: "macAddress",
                style: TableStyles.dataStyle,
                minWidth: 120
              },
              {
                Header: "",
                filterable: false,
                headerStyle: TableStyles.columnHeaderStyle,
                width: 80,
                sortable: false,
                Cell: row => (
                  <div>
                    {/* <button
                      className="iconButton"
                      onClick={() => {}}//this.handleView(row.original)}
                    >
                      <FontAwesomeIcon icon={faExclamationTriangle} />
                    </button>//TODO: Alarm status/Navigate to alarm page */}
                    <button
                      className="iconButton"
                      onClick={() => {
                        this.editData = row.original;
                        this.setState({ editModalOpen: true });
                      }}
                    >
                      <FontAwesomeIcon icon={faCog} />
                    </button>
                  </div>
                )
              },
            ]}
            // COLUMNS END //////////////////
           className="-highlight"
            SubComponent={row =>{
              return (
                <div style = {{ paddingLeft: "30px" }}>
                <ReactTable
                filterable={false}
                defaultFilterMethod={(filter, row) => (matchSorter([row[filter.id]], filter.value).length !== 0)}
                data = {this.state.presets.filter(x=> x.winderId === row.original.id)}
                columns={[
                  {
                    Header: "Preset 1",
                    headerStyle: TableStyles.columnHeaderStyle,
                    accessor: "preset1",
                    minWidth: 60
                  },
                  {
                    Header: "Preset 2",
                    headerStyle: TableStyles.columnHeaderStyle,
                    accessor: "preset2",
                    minWidth: 60
                  },
                  {
                    Header: "Preset 3",
                    headerStyle: TableStyles.columnHeaderStyle,
                    accessor: "preset3",
                    minWidth: 60
                  },
                  {
                    Header: "Preset 4",
                    headerStyle: TableStyles.columnHeaderStyle,
                    accessor: "preset4",
                    minWidth: 60
                  },
                  {
                    Header: "Preset 5",
                    headerStyle: TableStyles.columnHeaderStyle,
                    accessor: "preset5",
                    minWidth: 60
                  },
                  {
                    Header: "Preset 6",
                    headerStyle: TableStyles.columnHeaderStyle,
                    accessor: "preset6",
                    minWidth: 60
                  },
                  {
                    Header: "Preset 7",
                    headerStyle: TableStyles.columnHeaderStyle,
                    accessor: "preset7",
                    minWidth: 60
                  },
                  {
                    Header: "Preset 8",
                    headerStyle: TableStyles.columnHeaderStyle,
                    accessor: "preset8",
                    minWidth: 60
                  },
                  {
                    Header: "",
                    filterable: false,
                    headerStyle: TableStyles.columnHeaderStyle,
                    columns: [
                      {
                        width: 75,
                        sortable: false,
                        filterable: false,
                        Cell: row2 => (
                          <div>
                              <button
                                className="iconButton"
                                onClick={() => {
                                  this.editPreset = row2.original;
                                  this.editName= row.original.name
                                  this.setState({ editPresetModalOpen: true });
                                }}
                              >
                                <FontAwesomeIcon icon={faPencilAlt} />
                              </button>
                              </div>
                        )
                      },
                    ]
                  },
                ]}
                minRows = {1}
                showPagination = {false}
                
                />
                </div>
               
              )
            }}
          /> 
        </div>
          <EditWinderModal
            winder={this.editData}
            isModalOpen={this.state.editModalOpen}
            closeModal={this.closeModal}
            editWinder={this.editWinder}
            orgOptions={this.state.orgOptions}
            orgIndex={this.orgList.findIndex(x=>x.name===this.editData.ownerName)}
          />
          <EditPresetsModal
            presets={this.editPreset}
            isModalOpen={this.state.editPresetModalOpen}
            closeModal={this.closeModal}
            winderName={this.editName}
            editPresets={this.editPresets}
          />
        
      </React.Fragment>
    );
  }

  private getWinders = () => {
    this.getPromise!.newPromise(getAllWindersApi(), result => {
      this.setState({
        winders:result,
      });
    }, e=> {
      alert(`Error retrieving winders. ${e.detail}`)
    });
    this.getPresetsPromise!.newPromise(getAllPresetsApi(), result => {
      this.setState({
        presets:result,
      });
    }, e=> {
      alert(`Error retrieving presets. ${e.detail}`)
    })
  };

  handleAdd = () => {
    this.setState({
      addModalOpen: true
    });
  };

  private closeModal = () => {
    this.setState({
      addModalOpen: false,
      editModalOpen: false,
      editPresetModalOpen:false,
      //deleteModalOpen: false,
    });
    this.getWinders();
  }

  private addWinder = (newWinder:createWinder,orgIndex:number) => {
    if (orgIndex >= 0) {
      let org: orgInfo = this.orgList[orgIndex];
      if (org.orgType === orgTypes.Customer) {
        newWinder.customerId = org.id;
      }
      else if (org.orgType === orgTypes.Distributor) {
        newWinder.distributorId = org.id;
      }
    }
    this.addPromise!.newPromise(
      addWinderApi(newWinder), result => {
        this.getWinders();
      },
      e => {
        console.log(`Error caught in page-spoolWinder.addWinder(). ${e}`);
        alert('Error adding winder.');
      }
    )
  }

  private editWinder = (editData:editWinder,orgIndex:number) => {
    if (orgIndex >= 0) {
      let org: orgInfo = this.orgList[orgIndex];
      if (org.orgType === orgTypes.Customer) {
        editData.customerId = org.id;
      }
      else if (org.orgType === orgTypes.Distributor) {
        editData.distributorId = org.id;
      }
    }
    this.editPromise!.newPromise(
      editWinderApi(editData), result => {
        this.getWinders();
      },
      e => {
        console.log(`Error caught in page-spoolWinders.editWinder(). ${e}`);
        alert('Error editing winder.');
      }
    )
  }

  private editPresets = (editData:presetInfo) => {
    this.editPresetsPromise!.newPromise(
      editPresetApi(editData), result => {
        this.getWinders();
      },
      e => {
        console.log(`Error caught in page-spoolWinders.editPresets(). ${e}`);
        alert('Error editing presets.');
      }
    )
  }
}
